import { useFxWorkspaceContext } from '@mobile-mapping/providers';
import { DeleteConfirmationModal } from '@tcweb/connect-ui';
import { t } from '@trimble/i18n';
import { Component, createSignal } from 'solid-js';

export interface DeleteFxWorkspaceDialogProps {
  readonly workspaceId: string;
  readonly workspaceName: string;
  onClose(): void;
}

export const DeleteFxWorkspaceDialog: Component<
  DeleteFxWorkspaceDialogProps
> = (props) => {
  const fxWorkspace = useFxWorkspaceContext();
  const [isDeleting, setIsDeleting] = createSignal(false);

  const handleConfirm = async (): Promise<void> => {
    setIsDeleting(true);
    try {
      const deleted = await fxWorkspace.deleteWorkspace(props.workspaceId);
      if (deleted) {
        props.onClose();
      }
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <DeleteConfirmationModal
      title={t('mobileMapping.fxWorkspace.delete')}
      message={t('mobileMapping.fxWorkspace.deleteConfirm', {
        name: props.workspaceName,
      })}
      waiting={isDeleting()}
      overlayClass="z-modal"
      onCancel={props.onClose}
      onConfirm={() => {
        void handleConfirm();
      }}
    />
  );
};
